import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import {
  TextField,
  SelectField,
  EntitySelector,
  CheckBox,
  If,
  CurrencyField,
  IconButton,
  DescriptionField
} from "components/support";
import { Divider } from "material-ui";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";
import Typography from "material-ui-next/Typography";
import Barcodes from "./barcodes";
import OptionalGroups from "./optional-groups";
import { FormattedNumber } from "react-intl";
import { UnitLabels } from "core/enum";
import { observer } from "mobx-react";
import Big from "big.js";
import { fn } from "util";
import { colors, images } from "assets";
import style from "./style";

const UnitLabelsOptions = Object.values(UnitLabels).map(i => ({
  value: i.unit,
  label: i.name
}));

class ProductFormGeneralInfoView extends Component {
  handleCurrency = (field, value) => {
    this.props.product[field] = parseInt(
      Big(value)
        .times(100)
        .toString(),
      10
    );
  };

  linkedOptionalGroupsMap = linkedOptionalGroups => {
    return linkedOptionalGroups.map((optional, i) => (
      <Row center="xs" middle="xs" key={i}>
        <Col xs={2}>
          <If test={optional.enabled}>
            <Icon className="row-icon black-icon">done</Icon>
          </If>
          <If test={!optional.enabled}>
            <Icon className="row-icon red-icon">clear</Icon>
          </If>
        </Col>
        <Col xs>
          <DescriptionField value={optional.name || "Sem nome"} />
        </Col>
        <Col xs>
          <FormattedNumber
            value={fn.centsToReal(optional.value || 0)}
            format="BRL"
          >
            {value => <DescriptionField value={value} />}
          </FormattedNumber>
        </Col>
        <Col xs>
          <DescriptionField value={optional.mandatory_quantity || "Não tem"} />
        </Col>
        <Col xs>
          <DescriptionField value={optional.limited_value || "Não tem"} />
        </Col>
      </Row>
    ));
  };

  render() {
    const {
      className,
      presenter,
      product,
      viewModel,
      errors,
      mode,
      optionalGroupsOpen,
      onOptionalGroupsOpen,
      onOptionalGroupsClose,
      onOptionalGroupsSave,
      optionalGroupsUuids,
      linkedOptionalGroups,
      //hasSku,
      loading
      // variationsList,
      // fullVariationsListOptions,
      // variationsListOptions,
      // selectedVariations,
    } = this.props;
    const { categorySearchOptions /*newVariations*/ } = viewModel;

    return (
      <Row>
        <Col xs={12}>
          <div className={`${className} grid-container mt-sm mb-sm`}>
            <Row bottom="xs">
              <Col xs={12} lg style={{ marginLeft: 2 }}>
                <CheckBox
                  checked={product.type === "product_kit"}
                  label="É um Combo/Kit"
                  onCheck={checked =>
                    (product.type = { true: "product_kit", false: "product" }[
                      checked
                    ])
                  }
                />
              </Col>
            </Row>
            <Row bottom="xs">
              <Col xs={12} lg={4} style={{ marginTop: 6, textAlign: "center" }}>
                <img
                  src={product.image_url || images.placeholder}
                  style={{ width: 160, height: 90 }}
                  alt="UploadImage"
                  onError={env => (env.target.src = images.placeholder)}
                />
              </Col>
              <Col xs={12} lg={8}>
                <TextField
                  fullWidth
                  value={product.name}
                  errorText={errors.name}
                  label="Nome do Produto*"
                  onChange={(_, value) => (product.name = value)}
                />
                <TextField
                  fullWidth
                  value={product.image_url}
                  errorText={errors.name}
                  label="Url da Imagem"
                  onChange={(_, value) => (product.image_url = value)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={4}>
                <TextField
                  fullWidth
                  value={product.code}
                  label="Código"
                  errorText={errors.code}
                  onChange={(_, value) => (product.code = value)}
                />
              </Col>
              <Col xs={12} lg={4}>
                <SelectField
                  fullWidth
                  label="Unidade de Medida"
                  options={UnitLabelsOptions}
                  value={product.unit_label}
                  errorText={errors.unit_label}
                  onChange={(_, value) => (product.unit_label = value)}
                />
              </Col>
              <Col xs={12} lg={4}>
                <EntitySelector
                  label="Categoria"
                  title="Selecionar Categoria"
                  value={product.category.name}
                  searchOptions={categorySearchOptions}
                  onSelect={category => presenter.onSelectCategory(category)}
                  parser={category => ({
                    key: category.uuid,
                    title: category.name
                  })}
                  nullSelection={{ uuid: "", name: "" }}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={4}>
                <If test={mode === "edit"}>
                  <FormattedNumber
                    value={product
                      .getCostValue()
                      .div(100)
                      .toString()}
                    format="BRL"
                  >
                    {value => (
                      <DescriptionField label="Preço de Compra" value={value} />
                    )}
                  </FormattedNumber>
                </If>
                <If test={mode === "add"}>
                  <CurrencyField
                    allowNegative={false}
                    disabled={product.type === "product_kit"}
                    fullWidth
                    value={product
                      .getCostValue()
                      .div(100)
                      .toString()}
                    label="Preço de Compra"
                    unit="R$ "
                    errorText={errors.cost_value}
                    onChange={(_, value) =>
                      this.handleCurrency("cost_value", value)
                    }
                  />
                </If>
              </Col>
              <Col xs={12} sm={4}>
                <CurrencyField
                  fullWidth
                  unit=""
                  suffix="%"
                  value={product.getProfit().toString()}
                  label="Margem de Lucro"
                  onChange={(_, value) => product.setProfit(value)}
                  disabled="true"
                />
              </Col>
              <Col xs={12} sm={4}>
                <CurrencyField
                  allowNegative={false}
                  fullWidth
                  value={product
                    .getSellValue()
                    .div(100)
                    .toString()}
                  label="Preço de Venda*"
                  unit="R$ "
                  errorText={errors.sell_value}
                  onChange={(_, value) =>
                    this.handleCurrency("sell_value", value)
                  }
                />
              </Col>
            </Row>

            {/* TODO: This component is useless. Remove it */}
            <Barcodes
              sellable={product}
              errors={errors}
              editBarcode={(barcodeUuid, value) =>
                this.props.editBarcode(barcodeUuid, value)
              }
              deleteIndexError={index => this.props.deleteIndexError(index)}
            />

            <Row>
              <Divider className="mt-md full-width" />
            </Row>

            <If test={product.type === "product_kit"}>
              <Row center="xs" className="pt-md">
                <Col xs>
                  <Typography type="title">
                    Não é permitido vincular grupo de opcionais ao Combo/Kit.
                  </Typography>
                </Col>
              </Row>
            </If>

            <If test={!(product.type === "product_kit")}>
              <If test={linkedOptionalGroups.length > 0}>
                <Row center="xs" className="mv-md">
                  <Col xs>
                    <Typography type="title">
                      Grupos de Opcionais vinculados à este produto
                    </Typography>
                  </Col>
                </Row>
              </If>

              <Row>
                <Col xs={12} lg={2}>
                  <Row>
                    <div
                      className="create-sub-optionals"
                      onClick={async () => await onOptionalGroupsOpen(true)}
                    >
                      <Typography type="subheading">
                        Vincular Grupos de Opcionais
                      </Typography>
                      <IconButton
                        mini
                        icon="add"
                        iconStyle={{ color: `${colors.secondary.dark}` }}
                        className="icon-button-color"
                      />
                    </div>
                  </Row>
                </Col>

                <Col xs={12} lg={10}>
                  <If test={!linkedOptionalGroups.length}>
                    <Row middle="xs" className="full-height">
                      <Col xs>
                        <Typography align="center" type="title">
                          Não há Grupos de Opcionais associados à este produto
                        </Typography>
                      </Col>
                    </Row>
                  </If>

                  <If test={linkedOptionalGroups.length}>
                    <Row middle="xs" center="xs">
                      <Col xs={2}>
                        <Tooltip
                          key="tooltip-top-enable-opt-groups"
                          title="Acesse a página de grupos de opcionais para habilitar/desabilitar um grupo de opcional"
                          placement="top"
                        >
                          <div className="tooltip-div">
                            <Row center="xs" className="full-width">
                              <Col xsOffset={2} xs={3}>
                                <Icon className="tooltip-icon">info</Icon>
                              </Col>
                              <Col xs={6}>
                                <Typography type="subheading">
                                  Habilitada
                                </Typography>
                              </Col>
                            </Row>
                          </div>
                        </Tooltip>
                      </Col>
                      <Col xs>
                        <Typography type="subheading">Nome</Typography>
                      </Col>
                      <Col xs>
                        <Typography type="subheading">
                          Valor por Opcional
                        </Typography>
                      </Col>
                      <Col xs>
                        <Typography type="subheading">
                          Qtd Obrigatória
                        </Typography>
                      </Col>
                      <Col xs>
                        <Typography type="subheading">Qtd Máxima</Typography>
                      </Col>
                    </Row>

                    {this.linkedOptionalGroupsMap(linkedOptionalGroups)}
                  </If>
                </Col>

                <Col>
                  <OptionalGroups
                    optionalGroupsOpen={optionalGroupsOpen}
                    optionalGroupsUuids={optionalGroupsUuids}
                    linkedOptionalGroups={linkedOptionalGroups}
                    loading={loading}
                    onOptionalGroupsClose={async () =>
                      await onOptionalGroupsClose()
                    }
                    onOptionalGroupsSave={async updatedOptionalGroups =>
                      await onOptionalGroupsSave(updatedOptionalGroups)
                    }
                  />
                </Col>
              </Row>
            </If>
          </div>
        </Col>
      </Row>
    );
  }
}

export default style(observer(ProductFormGeneralInfoView));



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/general-info.view.js